(() => {
    "use strict";

    if (window.frAccess) {
        return;
    }

    const ACTIVE_STATUSES =
        new Set([
            "active",
            "trialing"
        ]);


    // ==========================================================
    // SUBSCRIPTIONS
    // ==========================================================

    function getSubscriptions() {

        return Array.from(
            document.querySelectorAll(
                "[data-member-subscription]"
            )
        ).map(
            (element) => ({
                status:
                    element.dataset
                        .subscriptionStatus || "",

                tierName:
                    element.dataset
                        .tierName || "",

                tierId:
                    element.dataset
                        .tierId || "",

                planId:
                    element.dataset
                        .planId || ""
            })
        );
    }


    // ==========================================================
    // MEMBER
    // ==========================================================

    function isSignedIn() {
        return Boolean(
            document.getElementById(
                "fr-member-data"
            )
        );
    }


    // ==========================================================
    // TIERS
    // ==========================================================

    function hasTier(tierName) {

        const target =
            String(tierName || "")
                .trim();

        if (!target) {
            return false;
        }

        return getSubscriptions()
            .some(
                (subscription) => {

                    return (
                        subscription.tierName ===
                        target &&
                        ACTIVE_STATUSES.has(
                            subscription.status
                        )
                    );
                }
            );
    }


    function hasAnyTier(tierNames) {

        if (!Array.isArray(tierNames)) {
            return false;
        }

        return tierNames.some(
            hasTier
        );
    }


    function getTierNames() {

        return getSubscriptions()
            .filter(
                (subscription) =>
                    ACTIVE_STATUSES.has(
                        subscription.status
                    )
            )
            .map(
                (subscription) =>
                    subscription.tierName
            )
            .filter(Boolean);
    }


    // ==========================================================
    // CONTENT VISIBILITY
    // ==========================================================

    function canDiscoverTitle(title) {

        const value =
            String(title || "");

        /*
         * $ prefix = TomAuthor-only discovery.
         */
        if (value.startsWith("$ ")) {
            return hasTier(
                "TomAuthorTier"
            );
        }

        return true;
    }


    // ==========================================================
    // PUBLIC API
    // ==========================================================

    window.frAccess = {
        isSignedIn,
        hasTier,
        hasAnyTier,
        getSubscriptions,
        getTierNames,
        canDiscoverTitle
    };

})();